var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron_left",
    "data-name": "chevron left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.281,
    height: 23.532,
    viewBox: "0 0 14.281 23.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_chevron-left",
    "data-name": "solid chevron-left",
    d: "M27.871,48.514,38.344,38.041a1.293,1.293,0,0,1,1.829,0l1.222,1.222a1.293,1.293,0,0,1,0,1.827l-8.3,8.339,8.3,8.339a1.293,1.293,0,0,1,0,1.827l-1.222,1.222a1.293,1.293,0,0,1-1.829,0L27.871,50.343A1.293,1.293,0,0,1,27.871,48.514Z",
    transform: "translate(-27.493 -37.662)",
    fill: "#3166b2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.f63f1cf26c7306ad9ed82053f7f6d6cb.svg";
export { ForwardRef as ReactComponent };